import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import {
    getUserImpersonatedCountry,
    getUserIsAuthenticated,
    selectUserDetails
} from '../../reducers/userReducer';
import { EvaluatedFeatureFlags, fetchEvaluatedFeatureFlags } from './EvaluatedFeatureFlagsApi';
import { FeatureFlagKeys } from './featureFlagKeys';
import { FeatureFlagVariantKeys } from './featureFlagVariantKeys';

export const evaluatedFeatureFlagsQueryKey = 'evaluated-feature-flags';

// The flags this client evaluates. Only these are ever requested from the backend.
const requestedKeys: string[] = [
    ...Object.values(FeatureFlagKeys),
    ...Object.values(FeatureFlagVariantKeys)
];

export function useEvaluatedFeatureFlagsQuery() {
    // Impersonation context goes into the key so impersonate / unimpersonate produces a
    // fresh cache entry instead of serving stale data from the previous user.
    const userDetails = useSelector(selectUserDetails);
    const impersonatedCountry = useSelector(getUserImpersonatedCountry);
    // The endpoint requires a bearer token. HeadBar renders on every route, signed in or not, so
    // without this gate a signed-out visitor would 401 and trip Api's signinSilent / removeUser /
    // reload recovery path.
    const isAuthenticated = useSelector(getUserIsAuthenticated);
    const userId = userDetails && userDetails.id != null ? userDetails.id : null;
    const countryId =
        impersonatedCountry && impersonatedCountry.id != null
            ? impersonatedCountry.id
            : null;

    return useQuery<EvaluatedFeatureFlags>(
        [evaluatedFeatureFlagsQueryKey, userId, countryId],
        () => fetchEvaluatedFeatureFlags(requestedKeys),
        {
            enabled: isAuthenticated === true,
            staleTime: 90 * 1000,
            refetchInterval: 90 * 1000,
            refetchOnWindowFocus: false
        }
    );
}
